import { render, staticRenderFns } from "./DeliveryLogDriverModal.vue?vue&type=template&id=189fbb25&scoped=true"
import script from "./DeliveryLogDriverModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryLogDriverModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189fbb25",
  null
  
)

export default component.exports